import { useEffect, useState } from "react";
import { Form, Flex, Select, Checkbox, Modal } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Paragraph from "antd/es/typography/Paragraph";
import { useApiCall } from "../../services/api";
import { setData } from "../../redux/auth/loginDataSlice";
import PrimaryButton from "../../components/Forms/PrimaryButton";
import Verification from "../../components/models/Verification";
import AppLogo from "../../components/AppLogo";
import { formRules, idTypeEnums, roleIds } from "../../constant";
import FormInput from "../../components/Forms/FormInput";
import Title from "antd/es/typography/Title";
import SelectTag from "../../components/Forms/SelectTag";
import { useGlobalModal } from "../../context/SuccessModalProvider";
import OtpModal from "../../components/models/OtpModal";
import Password from "../../components/models/Password";

const SignUp = () => {
  const { postApi, loading } = useApiCall();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showPopup } = useGlobalModal();
  const [isModalVisible, setIsModalVisible]=useState()
  const [formData, setFormData]=useState()
   const [step, setStep]=useState(1)
  const [agreeTo, setAgreeTo] = useState({
    terms: false,
    privacy: false,
  });
  const { role_id } = useSelector((state) => state.auth);

  const [form] = Form.useForm();
   const [showOtpModal, setshowOtpModal]=useState()
   const [showPolicyError, setShowPolicyError] = useState(false);
  const handlePassword = () => {
    navigate("/sales/forgot-password");
  };


  const checkboxDuplicate= async (values)=>{
    if(!agreeTo?.terms || !agreeTo?.privacy){
      return
    }
    const body = {
           email:values?.email,
           phone:values?.phone

    };
    const res = await postApi("customer/check-duplicate-customer", body);
    if (res?.status) {
      sendOptEmail(values)
      sendOptPhone(values)
      setFormData(values)
    }
    
    if (!res?.status) {
       return showPopup({
        title: null,
        content: <span className="custom-modal-title">{res.message}</span>,
        onOk: () => console.log(),
        className: "custom-success-modal",
      });
    }
  }

  const sendOptEmail=async(values)=>{
        const body = {
            email:values?.email,
            deviceType:"Web"

    };
    const res = await postApi("customer/register-send-otp-email", body,);
    return showPopup({
      title: null,
      content: (
        <span className="custom-modal-title">
          Please enter the OTPs sent to your phone and email.
        </span>
      ),
      onOk: () => {
        setIsModalVisible(true);
        setshowOtpModal(true);
      },
      className: "custom-success-modal",
    });

  }
  const sendOptPhone=async(values)=>{
        const body = {
           phone:values?.phone,
           email:values?.email,
           deviceType:"Web"

    };
    const res = await postApi("customer/register-send-otp-phone", body,);

  }


  const handleResendOtp = async (type = "email", showResponse = false) => {
    const data = { [type]: formData[type], deviceType: "Web" };
    if (type === "phone") {
      data["email"] = formData["email"];
    }
    const apiRoute = `customer/register-send-otp-${type}`;
    const res = await postApi(apiRoute, data, showResponse);

    if (res && res?.status) {
      return true;
    }
    return false;
  };

  const handleFinish=()=>{
    setIsModalVisible(false)
    setStep(2)
     setIsModalOpen(false)
  }

  const handleSubmit = async (values) => {
    const body = {
      ...values,
      type: values.username?.includes("@") ? "email" : "phone",
      is_agree_terms: 1
    };

    const res = await postApi("customer/register", body);
    if (res?.status) {
      setIsModalOpen(true)
      setIsModalVisible(false)
    }else{
      setIsModalOpen(false)
    }
  };

    const onClose = () => {
      setIsModalOpen(false)
    setIsModalVisible(false);
  };

  useEffect(() => {
    if(showPolicyError){
      showPopup({
        title: null,
        content: (
          <span className="custom-modal-title">
           You must agree to our Terms & Conditions and Privacy Policy
        </span>
      ),
      onOk: () => setShowPolicyError(false),
      className: "custom-success-modal",
    });
  }
  }, [showPolicyError]);

  return (
    <>
      <div className="container-full">
        <div className={`min-h-screen bg-[#A33434] bg-style`}>
          <div className="min-h-screen py-10 flex justify-center items-center">
            <div className="border  w-[90%] md:w-[60%] lg:w-[40%] p-[36px] rounded-[32px] bg-[#FFFFFFCC] backdrop-blur-154">
              <AppLogo />
              <div className="w-full">
                 {step==1 && (
                    <>
                <p className="text-[64px] mt-4 mb-0 font-normal text-[#353535] font-abhaya">Welcome!</p>
                 
                 <p className="mt-0 mb-10 font-normal text-base">You can sign up to our platform using your email and phone number. 
                  Please enter your Company information below.</p>
                {/* --- Ant Design Form --- */}
                <Form
                  form={form}
                  layout="vertical"
                  className="max-w-full mx-auto"
                      onFinish={(values) => {
                        if (!agreeTo.terms || !agreeTo.privacy) {
                          setShowPolicyError(true);
                          return;
                        }
                        setShowPolicyError(false);
                        checkboxDuplicate(values);
                      }}
                  autoComplete="off"
                >

                  {/* Group 1 */}
                  <Flex justify="space-between">
                    <FormInput
                      label={<span className="text-[16px]">Company Name</span>}
                      name={"company_name"}
                      rules={formRules.required}
                      style={{ width: "48%" }}
                      className={"!rounded-2xl"}
                    />
                    <FormInput
                      label={<span className="text-[16px]">Contact Person Name</span>}
                      name={"contact_person"}
                      rules={formRules.required}
                      style={{ width: "48%" }}
                      className={"!rounded-2xl"}
                    />
                  </Flex>

                  {/* Group 2 */}
                  <Flex justify="space-between">
                    <FormInput
                      label={<span className="text-[16px]">Company Email Address</span>}
                      name="email"
                      rules={formRules.email}
                      style={{ width: "48%" }}
                      type="text"
                      className={"!rounded-2xl"}
                    />
                    <FormInput
                      label={<span className="text-[16px]">Company Phone No.</span>}
                      name="phone"
                      rules={formRules.phone}
                      maxLength={10}
                      style={{ width: "48%" }}
                      className={"!rounded-2xl"}
                    />
                  </Flex>
                  <FormInput
                    label={<span className="text-[16px]">Address Line 1</span>}
                    name={"address_line1"}
                    rules={formRules.required}
                    className={"!rounded-2xl"}
                  />
                  <FormInput
                    label={<span className="text-[16px]">Address Line 2</span>}
                    name={"address_line2"}
                    rules={formRules.required}
                    className={"!rounded-2xl"}
                  />
                  <Flex justify="space-between">
                    <FormInput
                      label={<span className="text-[16px]">City</span>}
                      name={"city"}
                      rules={formRules.required}
                      style={{ width: "48%" }}
                      className={"!rounded-2xl"}
                    />
                    <Form.Item
                      rules={formRules.required}
                      label={<span className="text-[16px]">State</span>}
                      name={"state"}
                      style={{ width: "48%" }}
                      className={"!rounded-2xl"}
                    >
                      <SelectTag />
                    </Form.Item>
                  </Flex>
                  <FormInput
                    label={<span className="text-[16px]">Postal Code</span>}
                    name={"post_code"}
                    rules={formRules.postalCode}
                    className={"!rounded-2xl"}
                    maxLength={6}
                  />

                  <Flex justify="space-between">
                    <FormInput label={<span className="text-[16px]">Zone</span>} name="zone" style={{ width: "48%" }} className={"!rounded-2xl"} />
                    <FormInput label={<span className="text-[16px]">Area</span>} name="area" style={{ width: "48%" }} className={"!rounded-2xl"} />
                  </Flex>
                  <Flex justify="space-between">
                    <Form.Item
                      label={<span className="text-[16px]">ID Type</span>}
                      name="id_type"
                      rules={formRules.required}
                      style={{ width: "48%" }}
                      className={"extra-class"}
                    >
                      <Select  size="large" style={{ height: "47px"}} placeholder="Select ID Type" >
                        {idTypeEnums.client.map((item) => (
                          <Select.Option key={item} value={item}>
                            {item}
                          </Select.Option>
                        ))}
                        
                      </Select>
                    </Form.Item>
                    <FormInput
                      label={<span className="text-[16px]">ID Number</span>}
                      name={"id_no"}
                      rules={formRules.required}
                      style={{ width: "48%" }} className={"!rounded-2xl"}
                    />
                  </Flex>

                  <FormInput label={<span className="text-[16px]">Agent Name</span>} name={"agent_name"} className={"!rounded-2xl"} />

                  <FormInput label={<span className="text-[16px]">Remarks</span>} name={"agent_remark"} className={"!rounded-2xl"} />
                  <div className="w-full my-0 flex flex-col">
                    <Paragraph className="!mb-0 w-fit">
                      By clicking proceed you acknowledge that you have read and agree to our :
                    </Paragraph>

                    <Checkbox
                      className="mt-2 underline"
                      onChange={(e) => {setAgreeTo({ ...agreeTo, terms: e.target.checked });
                       setShowPolicyError(false)}}
                      checked={agreeTo.terms}
                      rules={formRules.required}
                    >
                      <p className="cursor-pointer underline  font-bold font-manrope" onClick={() => window.open("/terms-and-conditions", "_blank")}>
                        Terms and Conditions
                      </p>
                    </Checkbox>
                    <Checkbox
                      className="mt-2 underline"
                      onChange={(e) => {setAgreeTo({ ...agreeTo, privacy: e.target.checked });
                       setShowPolicyError(false)}}
                      checked={agreeTo.privacy}
                      rules={formRules.required}
                    >
                      <p className="cursor-pointer underline  font-bold font-manrope" onClick={() => window.open("/privacy-policy", "_blank")}>
                        Privacy Policy
                      </p>
                    </Checkbox>
                  </div>


                  <div className="w-full flex flex-col gap-3 justify-center">
                    <div className="w-full mt-4 flex justify-center">
                      <PrimaryButton
                        text="Proceed"
                        type="submit"
                        htmlType="submit"
                        loading={loading}
                        className="me-[30px]"
                      />
                    </div>
                    <div className="mx-auto flex flex-col justify-center">
                      <Paragraph className="!mb-0 w-fit">Already have an account?</Paragraph>
                      <p className="text-center cursor-pointer underline text-base font-bold font-manrope !leading-[1]" onClick={() => navigate("/login")}>
                        Login
                      </p>
                    </div>
                  </div>

                </Form>
                </>
                  )}

                  {step==2 && (
                    <div>
                    <p className="text-[45px] md:text-[50px] my-4 font-normal text-[#353535] font-abhaya">
                      {"Set Password"}
                    </p>
                  <Password
            handleFinish={(values) => {
              setFormData({ ...formData, ...values }) ; handleSubmit({ ...formData, ...values })
            }}
            setStep={setStep}
            formData={formData}
            setFormData={setFormData}
            formType={'client'}
            title={""}
            loading={loading}
            is_customer={true}
          />
          </div>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        className="form-css w-max-[600px]"
      open={isModalVisible}
      onOk={onClose}
      footer={null}
      onCancel={onClose}
      width={500}
      destroyOnHidden>
          <OtpModal
            formType={"client"}
            step={showOtpModal}
            formData={formData}
            handleResendOtp={handleResendOtp}
            handleFinish={handleFinish}
            title={`OTP Verification`}
            is_customer={true}
          />
          </Modal>

      <Verification isOpen={isModalOpen} signUp={true} closeModal={() => setIsModalOpen(false)} />
    </>
  );
};

export default SignUp;
